export default "__VITE_ASSET__ajeRcSMN__"